export default function validateMinMax(min, max, msg) {
  if (!min || !max) {
    return;
  }

  // eslint-disable-next-line consistent-return
  return max < min ? msg : undefined;
}
